export default __webpack_public_path__ + "static/media/db_logo.29448d4d.png";